export enum Action {
	CREATE = 'CREATE',

	UPDATE = 'UPDATE',

	RESTORE = 'RESTORE'
}
